<template>
	<div>
	  <v-tab-item class="pb-0" >
		<validation-observer ref="observer" slim v-slot="{ valid }">
		  <validation-helper
			:interceptor="valid"
			@isValid="
			  $emit('step-observer', {step: 0, complete: $event}),
			  $emit('step-observer', {step: 1, complete: true})
			"
		  />
		  <v-row>
			<v-dialog
				v-model="dialogSalvarMapeamento"
				width="720"
			>
				<v-card>
					<v-card-title class="text-h5 grey lighten-2">
						Salvar Mapeamento
					</v-card-title>
					<div v-if="mapeamentoHexa">
						<v-card-text>
							Tem certeza que deseja atualizar o Mapeamento?
						</v-card-text>
					</div>
					<div v-else >
						<validation-provider  v-slot="{ errors }" rules="required">
							<v-text-field
								class="pa-5"
								label="Nome do Mapeamento" 
								v-model="novoMapeamento"
								:error-messages="errors"
							/>
						</validation-provider>
					</div>

					<v-divider></v-divider>

					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
							color="success"
							text
							@click="salvarMapeamento()"
						>
							Salvar
						</v-btn>
						<v-btn
							color="primary"
							text
							@click="dialogSalvarMapeamento = false"
						>
							Cancelar
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<v-dialog
				v-model="dialogCamposNaoEncontrados"
				width="720"
			>
				<v-card>
					<v-card-title class="text-h5 grey lighten-2">
						Atenção
					</v-card-title>
					<v-card-text class="pt-4">
						<v-alert
							dense
							outlined
							type="error"
							color="red"
							class="mb-0"
						>
							<strong>Atenção, não foi possível encontrar os seguintes campos em seu arquivo:</strong>
							<div class="mt-2">
								<div
									v-for="campo in camposNaoEncontradosMapeamento"
									:key="campo"
								>
									{{ campo }}
								</div>
							</div>
						</v-alert>
					</v-card-text>

					<v-divider></v-divider>

					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
							color="primary"
							text
							@click="dialogCamposNaoEncontrados = false"
						>
							OK
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<v-col cols="12" class="px-6 mt-0">
			  <validation-provider v-slot="{ errors }" rules="required"  id="upload-arquivo-importador">
				<v-file-input
				  @change="uploadNewFile"
				  label="Arquivo CSV"
				  placeholder="Selecione um arquivo CSV"
				  outlined
				  accept=".csv"
				  v-model="arquivo.fileObj"
				  loader-height="4"
				  :loading="arquivo.uploading"
				  truncate-length="30"
				  :error-messages="errors"
				  :success="arquivo.id && arquivo.fileObj ? true : false"
				/>
			  </validation-provider>
			  <validation-provider rules="required">
				<input type="hidden" :value="arquivo.id" />
			  </validation-provider>
			</v-col>
		  </v-row>
		  <parametros-arquivo-csv 
			id="parametros-csv"
			:delimitador.sync="arquivo.delimitador"
			:involucro.sync="arquivo.involucro"
			:escape.sync="arquivo.escape"
		  />
		  <v-row align="center" class="px-3">
			<v-col cols="12" :sm="tipoAis ? 4 : 6">
			  <general-encoding 
				id="encoding-arquivo"
				:encoding.sync="encoding"
			  />
			</v-col>
			<v-col cols="12" :sm="tipoAis ? 4 : 6">
			  <validation-provider v-slot="{ errors }" rules="required" id="tipo-mapeamento">
				<v-select
				  :error-messages="errors"
				  v-model="tipoImpo"
				  label="Tipo"
				  :items="itemsTipo"
				  item-text="descricao"
				  item-value="id"
				  outlined
				  no-gutters
				  class="pb-0"
				/>
			  </validation-provider>
			</v-col>
			<!--v-col cols="12" v-if="tipoAis" sm="4">
			  <date-picker
				v-model="dataAis"
				label="Data do AIS"
				type="month"
				:outlined="true"
				rules="required|min:7"
			  />
			</v-col-->
		  </v-row>
		  <v-row align="center"  class="px-3">
			<v-col cols=12>
			  <v-textarea
				id="descricao-importacao-dados"
				outlined
				label="Descrição (opicional)"
				hide-details
				placeholder="Insira uma breve descrição sobre a importação (Opicional)"
				rows="5"
				no-resize
				v-model="descricao"
			  />
			</v-col>
		  </v-row>
		</validation-observer>
	  </v-tab-item>
	  <v-tab-item class="pb-0" eager>
		<v-row align="center" justify="space-between" class="px-3 mapeamento-actions-row">
			<v-col cols="12" md="8" lg="7" class="pb-0">
				<v-select
					dense
					label="Mapeamento"
					:items="mapeamentos"
					item-text="mapeamento"
					item-value="id"
					v-model="mapeamentoHexa"
					clearable
					no-data-text="Nenhum campo disponível."
					hide-details="auto"
				/>
			</v-col>
			<v-col cols="12" md="auto" class="d-flex justify-md-end pt-0">
				<v-btn
					color="success"
					elevation="1"
					class="mt-2 mt-md-0"
					text
					medium
					@click="dialogSalvarMapeamento = true;"
				>
					Salvar Mapeamento
				</v-btn>
			</v-col>
		</v-row>
		<v-row v-if="camposNaoEncontradosMapeamento.length" class="px-3">
			<v-col cols="12" class="pt-0">
				<v-alert
					dense
					outlined
					type="error"
					color="red"
					class="mt-3 mb-2"
				>
					<strong>Atenção, não foi possível encontrar os seguintes campos em seu arquivo:</strong>
					{{ camposNaoEncontradosMapeamento.join(', ') }}
				</v-alert>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12">
				<div class="mapeamento-table-wrapper">
				<v-simple-table dense class="mapeamento-table">
					<template v-slot:default>
					<thead>
						<tr>
							<td>Coluna Arquivo</td>
							<td>Valor Arquivo</td>
							<td>Campo no Hexa</td>
							<td>Tipo do Dado</td>
							<td>Formato do Dado</td>
							<td>Máscara</td>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(value, key) in cabecalhoArquivo">
							<td class="col-arquivo">
								<strong class="d-inline-flex">{{ value }}
								</strong>
							</td>
							<td class="col-valor">
								<strong class="d-inline-flex">{{ linhaArquivo[key] }}
								</strong>
							</td>
							<td class="col-campo-hexa"> 
								<v-select
									dense
									:items="camposHexa"
									item-text="campo_sistema_descricao"
									item-value="id"
									v-model="mapeamento[key].campo_hexa"
									@change="autoloadOtherColumns(key)"
									clearable
									no-data-text="Nenhum campo disponível."
								/>
							</td>
							<td class="col-tipo-dado"> 
								<v-select
									dense
									:items="tipoDados"
									v-model="mapeamento[key].tipo_dado"
									clearable
									no-data-text="Nenhum campo disponível."
								/>
							</td>
							<td class="col-formato-dado"> 
								<v-select
									dense
									:items="mapeamento[key].formatoDadosOptions"
									v-model="mapeamento[key].formato_dado"
									clearable
									no-data-text="Nenhum campo disponível."
								/>
							</td>
							<td class="col-mascara"> 
								<v-select
									dense
									:items="mascarasOptions"
									v-model="mapeamento[key].mascara"
									@change="loadMascaraParameters(key)"
									clearable
									no-data-text="Nenhum campo disponível."
								/>
								<v-text-field
									v-if="mapeamento[key].mascara != ''"
									:label="mapeamento[key].mascara_parametros"
									v-model="mapeamento[key].mascara_parametros_valores"
								/>
							</td>
						</tr>
					</tbody>
					</template>
				</v-simple-table>
				</div>
			</v-col>
		</v-row>
	  </v-tab-item>
	</div>
  </template>
  
  <script>
  import ArquivosService from "@/services/ArquivosService.js"
  import PreImportacoesDadosService from "@/services/PreImportacoesDadosService.js"
  
  export default {
	components: {
	  ValidationHelper: () => import("@/components/general/ValidationHelper.vue"),
	  ParametrosArquivoCsv: () => import("@/components/general/GeneralParametrosArquivoCsv.vue"),
	  GeneralEncoding: () => import("@/components/general/GeneralEncoding.vue"),
	  DatePicker: () => import("@/components/general/DatePicker.vue")
	},
  
	props: {
	  itemsTipo: {
			type: Array,
			default: () => []
	  },
	},
  
	data: () => ({
	  arquivo: {
			nome:'',
			fileObj: undefined,
			encoding: '',
			id: "",
			delimitador: `;`,
			involucro: `"`,
			escape: `"`,
			uploading: false
	  },
	  tipoDados:[
			'texto',
			'inteiro',
			'decimal',
			'data',
			'data-hora',
			'hora'
	  ],
	  mapeamento: [],
	  novoMapeamento: '',
	  cabecalhoArquivo: {},
	  linhaArquivo: {},
		  camposHexa: [],
	  formatoDados: {},
	  mascaras: {},
	  mascarasOptions: [],
	  mapeamentos: [],
	  dataAis:'',
	  tipoAis: false,
	  encoding: "UTF-8",
	  tipoImpo:'',
	  descricao:'',
	  invalid: false,
	  mapeamentoHexa:'',
	  camposNaoEncontradosMapeamento: [],
	  triggerSalvarMapeamento: false,
	  dialogSalvarMapeamento: false,
	  dialogCamposNaoEncontrados: false,
	}),
	
	watch:{

		mapeamento(newValue){
			this.triggerSalvarMapeamento = true
		},

			mapeamentoHexa(newValue) {
				this.camposNaoEncontradosMapeamento = [];
				this.dialogCamposNaoEncontrados = false;
				if (!newValue) return;

				PreImportacoesDadosService.getMapeamento(this.mapeamentoHexa)
			.then((resp) => {
				const indicesMapeados = [];
				resp.data.mapeamento.pre_mapeamentos_importacao.forEach(element => {
					const indexMapeamento = this.mapeamento.findIndex((element2, index) => (
						element.coluna_arquivo == element2.campo_arquivo && !indicesMapeados.includes(index)
					));
					if (indexMapeamento === -1) {
						const campoSistemaDescricao = element.campo_sistema && element.campo_sistema.campo_sistema_descricao
							? element.campo_sistema.campo_sistema_descricao
							: element.campo_sistema_descricao;
						this.camposNaoEncontradosMapeamento.push(`${element.coluna_arquivo} x ${campoSistemaDescricao}`);
						return;
					}

					const element2 = this.mapeamento[indexMapeamento];
					element2.campo_hexa 				= element.campo_sistema_id
					element2.tipo_dado 					= element.coluna_arquivo_tipo_dados
					element2.formatoDadosOptions 		= this.formatoDados[element.coluna_arquivo_tipo_dados]
					element2.formato_dado 				= element.coluna_arquivo_formato_dados
					element2.mascara 					= element.coluna_arquivo_mascara
					element2.mascara_parametros_valores = element.coluna_arquivo_mascara_parametro
					indicesMapeados.push(indexMapeamento);
					this.triggerSalvarMapeamento = false
				})
				if (this.camposNaoEncontradosMapeamento.length) {
					this.dialogCamposNaoEncontrados = true;
				}
			})
			.catch(() => { 
				this.$toast.error(`Erro ao buscar mapeamento.`, '', {position: 'topRight'})
			});
		},

			tipoImpo(newValue) {
				this.camposHexa = [];
				this.formatoDados = {};
				this.mascaras = {};
				this.mascarasOptions = [];
				this.mapeamentos = [];
				this.mapeamentoHexa = '';
				this.camposNaoEncontradosMapeamento = [];
				this.dialogCamposNaoEncontrados = false;
				this.mapeamento.forEach(item => {
					item.campo_hexa = '';
					item.campo_hexa_descricao = '';
					item.tipo_dado = '';
					item.formatoDadosOptions = [];
					item.formato_dado = '';
					item.mascara = '';
					item.mascara_parametros = '';
					item.mascara_parametros_valores = '';
				});
				if (!newValue) return;
				PreImportacoesDadosService.getCamposHexa(newValue)
			.then((resp) => {
				this.camposHexa = resp.data.campos				
				this.formatoDados = resp.data.formatos
				this.mascaras = resp.data.mascaras
				this.mascarasOptions = Object.keys(resp.data.mascaras)

				Object.entries(resp.data.mapeamentos).forEach(element => {
					if (!element[0] || !String(element[1]).trim()) return;

					let obj = {
						id: element[0],
						mapeamento: element[1]
					}
					this.mapeamentos.push(obj)
				})
			})
			.catch(() => { 
				//this.$toast.error(`Erro ao buscar campos Hexa.`, '', {position: 'topRight'})
			});
	  	},
	},

	methods:{  
		loadMascaraParameters(key) {
			Object.entries(this.mascaras).forEach(element => {
				if(element[0] == this.mapeamento[key].mascara){
					this.mapeamento[key].mascara_parametros = element[1]['parametros'].join(',')
				}
			})
		},

		  autoloadOtherColumns(index) {
				const element = this.camposHexa.filter(obj => {
					return obj.id === this.mapeamento[index].campo_hexa
				})[0];
				if (!element) return;

				this.mapeamento[index].tipo_dado = element.campo_tabela_tipo_dados
			
			if(this.mapeamento[index].tipo_dado != 'texto'){
				this.mapeamento[index].formatoDadosOptions = this.formatoDados[element.campo_tabela_tipo_dados]
				this.mapeamento[index].formato_dado = this.formatoDados[element.campo_tabela_tipo_dados][0]
			}
	
	  },

	  uploadNewFile() {
		if (!this.arquivo.fileObj) return;
		
			this.arquivo.nome = this.arquivo.fileObj.name;
			this.arquivo.id = "";
			this.cabecalhoArquivo = {};
			this.linhaArquivo = {};
			this.mapeamento = [];
			this.camposNaoEncontradosMapeamento = [];
			this.dialogCamposNaoEncontrados = false;
			this.arquivo.uploading = true;
  
		let data = new FormData();
		data.append("file", this.arquivo.fileObj);
		ArquivosService.uploadFile(data)
		.then((resp) => {
			this.arquivo.id = resp.data.arquivoId

			this.arquivo.encoding = this.encoding
			PreImportacoesDadosService.getCabecalhoComPrimeiraLinhaArquivo(this.arquivo)
			.then((resp) => {
				this.cabecalhoArquivo = resp.data.cabecalho
				//fill mapeamento
				this.cabecalhoArquivo.forEach(cabecalho => {
					let obj = {
						campo_arquivo: cabecalho,
						campo_hexa: '',
						campo_hexa_descricao: '',
						tipo_dado: '',
						formato_dado: '',
						mascara: '',
						mascara_parametros: '',
						mascara_parametros_valores: ''
					}
					this.mapeamento.push(obj)
				})
				this.linhaArquivo = resp.data.linha
				this.triggerSalvarMapeamento = false
			})
			.catch(() => { 
				this.$toast.error(`Erro ao buscar cabeçalho do arquivo.`, '', {position: 'topRight'})
			});
	  	})
		.catch(() => this.$toast.error("Erro no upload do arquivo.", "", { position: "topRight" }))
		.finally(() => this.arquivo.uploading = false);
	  },

		  salvarMapeamento() {
			if (!this.mapeamentoHexa && !this.novoMapeamento.trim()) {
				this.$toast.error(`Informe o nome do mapeamento.`, '', {position: 'topRight'});
				return;
			}
			if (!this.tipoImpo) {
				this.$toast.error(`Selecione o tipo da importação.`, '', {position: 'topRight'});
				return;
			}

			const postData = {
			nome: this.novoMapeamento.trim(),
			mapeamento_id: this.mapeamentoHexa,
			tipo: 'PRE_MAPEAMENTO_IMPORTACAO_DADOS',
			tipo_importacao_id: this.tipoImpo,
			mapeamento: this.mapeamento
		};

			PreImportacoesDadosService.salvarMapeamento(postData)
			.then((resp) => {
				if (!this.mapeamentoHexa) {
					this.mapeamentoHexa = resp.data.mapeamento_id;
					this.mapeamentos.push({
						id: resp.data.mapeamento_id,
						mapeamento: this.novoMapeamento
					});
				}
				this.dialogSalvarMapeamento = false
				this.$toast.success(`Mapeamento Salvo.`, '', {position: 'topRight'})
		})
		.catch((error) => {
			const message = error && error.data && error.data.erro
				? error.data.erro
				: `Erro ao atualizar mapeamento.`;
			this.$toast.error(message, '', {position: 'topRight'})
		});
	  },
  
	  exportData() {

			this.camposHexa.forEach(element => {
				this.mapeamento.forEach(element2 => {
					if( element.id ==  element2.campo_hexa){ 
						element2.campo_hexa_descricao = element.campo_sistema_descricao
						return
					}
				})				
			})


			return {
				nomeArquivo: this.arquivo.nome,
				descricao: this.descricao,
				mapeamento_id: this.mapeamentoHexa,
				arquivoId: this.arquivo.id,
				encoding: this.encoding,
				delimitador: this.arquivo.delimitador,
				involucro: this.arquivo.involucro,
				escape: this.arquivo.escape,
				mapeamento: this.mapeamento,
				tipo_importacao_id: this.tipoImpo,
					pre_importacao_adm: true,
					//parametros_extras: this.formatarDataAis(this.dataAis)
				}
		  },

		  validateBeforeSave() {
				if (!this.arquivo.id) {
					this.$toast.error(`Selecione um arquivo CSV.`, '', {position: 'topRight'});
					return false;
				}
				if (!this.tipoImpo) {
					this.$toast.error(`Selecione o tipo da importação.`, '', {position: 'topRight'});
					return false;
				}
				const camposMapeados = this.mapeamento.filter(item => item.campo_hexa);
				if (!camposMapeados.length) {
					this.$toast.error(`Mapeie ao menos uma coluna do arquivo.`, '', {position: 'topRight'});
					return false;
				}
				const incompletos = camposMapeados.some(item => !item.tipo_dado);
				if (incompletos) {
					this.$toast.error(`Preencha o tipo dos dados para todas as colunas mapeadas.`, '', {position: 'topRight'});
					return false;
				}
				return true;
		  },
  
	  /*formatarDataAis(data) {
		if (data === '') return null;
  
		const [ano, mes, dia] = data.split('-');
		return {DataRegistro: `${dia}/${mes}/${ano}`};
	  },*/
	}
  }
  </script>

  <style scoped>
  .mapeamento-table-wrapper {
	overflow-x: auto;
  }

  .mapeamento-actions-row {
	gap: 12px;
  }

  .mapeamento-table {
	min-width: 1320px;
  }

  .mapeamento-table .col-arquivo {
	min-width: 220px;
  }

  .mapeamento-table .col-valor {
	min-width: 220px;
  }

  .mapeamento-table .col-campo-hexa {
	min-width: 420px;
  }

  .mapeamento-table .col-tipo-dado,
  .mapeamento-table .col-formato-dado,
  .mapeamento-table .col-mascara {
	min-width: 180px;
  }

  .mapeamento-table td {
	vertical-align: top;
  }
  </style>
